export function assertNumber(
  n: unknown,
  variableName: string
): asserts n is number {
  if (typeof n !== 'number') {
    throw `Input "${variableName}" is of invalid type "${typeof n}".  Should be of type "number".`;
  }
}
